import React, {useState} from "react";

import './Team.delete.dialog.scss';
import Modal from "react-modal";
import {useMutation} from "@apollo/client";
import gqlSchemaLibrary from "../../services/graphql.schemas";
import {Navigate} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {ModalLog} from "../../services/interactions/elements/modal";
import AuditTrail from "../../services/interactions/audit.trail";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};
Modal.setAppElement('#root');

const _Modal = ModalLog(Modal);

function TeamDeleteDialog({event, team, teams, redirect, openModal, closeModal}) {
    const {t} = useTranslation(['common','teams']);
    const [__submitting, __setSubmitting] = useState(false);

    const closeModalEmpty = () => {
        AuditTrail.sendLog(event, {tag: 'button', event: 'closeModal', action: 'button modal cancel delete teams', teamIds: team? [team._id] : teams.map((t) => t._id)});
        closeModal();
    }

    const [deleteTeams] = useMutation(gqlSchemaLibrary.teams.mutation.deleteTeams, {
        onCompleted: ({ deleteTeams }) => {
            __setSubmitting(false);
            if (redirect) {
                Navigate(`/teams`);
            } else {
                closeModal(team? [team] : teams);
            }
        },
        onError: (e) => {
            console.error('Rename Team Error: ', e);
            __setSubmitting(false);
        }
    });

    const onDelete = () => {
        if (__submitting) {
            return;
        }
        AuditTrail.sendLog(event, {tag: 'onSubmit', event: 'delete', action: 'button delete teams', teamIds: team? [team._id] : teams.map((t) => t._id)});
        __setSubmitting(true);
        deleteTeams({
            variables: {
                teamIds: team? [team._id] : teams.map((t) => t._id)
            }
        });
    }

    const getName = () => {
        if (team || teams.length === 1) {
            const _team = team? team : teams[0];
            return (
                <>
                    {t('teams:remove-team')} <b>{_team.name}</b>
                </>
            );
        }
        return (
            <>
            {t('remove')} <b>{teams.length}</b> {t('teams:team')}{teams.length===1? '' : 's'}
            </>
        );
    }

    const getConfirmButton = () => {
        if (team || teams.length === 1) {
            return (
                <>
                    {t('teams:remove-team')}
                </>
            );
        }
        return (
            <>
                {t('teams:remove-teams')}
            </>
        );
    }

    return (
        <_Modal
            isOpen={!!openModal}
            style={customStyles}
            onRequestClose={closeModalEmpty}
            contentLabel="Rename team"
            label="TeamDeleteDialog"
            event={event}
            eventParams={{teamIds: team? [team._id] : teams.map((t) => t._id)}}>
            <div id="TeamDeleteDialog">
                <div className="__MembersTitle">
                    <i className="material-icons" onClick={closeModalEmpty}>arrow_back_ios</i>
                    <h3>{getName()}</h3>
                </div>
                <div className="__Container">
                    <p>
                        {t('teams:delete-team-information')}
                    </p>
                    <div className="containerButtons">
                        <button className="primary gray" onClick={closeModalEmpty}>
                            {t('cancel')}
                        </button>
                        <button disabled={false} className="primary blue" onClick={onDelete}>
                            {getConfirmButton()}
                        </button>
                    </div>
                </div>
            </div>
        </_Modal>
    );
}

export default TeamDeleteDialog;
